/* Carnis – kjøpsvalg v12 (okt. 2026, tilbudsrad for mengderabatt; kjøpslinja bare etter at knappen er scrollet forbi; nye priser, Carnis-pakke-abonnementet og mengderabatt ved engangskjøp). Brukes av snippets/carnis-kjop.liquid på
   produktsidene, forsiden, kolleksjonen og pakkesiden. Lastes på alle sider fra sections/carnis-header-stil.liquid.
   - Engangskjøp: «Prøv 1 krukke» / «Prøv 1 boks» / «Prøv pakken» med antallsvelger, total i valget og på knappen.
   - Carnis-pakke-abonnementet (Storfetalg og Organmix, cfg.abo): to antallsvelgere (0–12 hver), levering hver 1, 2 eller
     3 måneder. Minst 3 varer til sammen, ellers «Velg minst 3 til sammen» og sperrede knapper.
     «Abonner» legger linjene i handlekurven (/cart/add.js, én linje per produkt med planen for produktet og
     intervallet) og går til handlekurven. «Abonner med Vipps» lenker til cfg.abo.vipps?talg=…&organmix=…&mnd=….
     Mangler planen for et valgt produkt/intervall, er «Abonner» sperret med «Abonnement åpner snart».
   - Carnis-pakken: bare engangskjøp.
   - Mengderabatt ved engangskjøp (cfg.once.tierMin/tierEach fra produktmetafeltet custom.mengderabatt, f.eks. 3:259):
     fra tierMin stk vises tierEach per krukke, engangsprisen gjennomstreket, sparingen og riktig total på knappen
     (samme pris som den automatiske rabatten gir i handlekurven). Tilbudsraden «… Velg 3 →» setter antallet; fra 3 stk vises en bekreftet rad.
   - ?kjop=abonnement i adressen velger abonnementet på produktsiden.
   - Produktsiden: oppdaterer prisen under tittelen, kjøpslinja nederst og elementer med data-ck-show (hendelsen «carnis:kjop»).
   - Nov. 2026 (v13): «3-pakk – bland selv» (cfg.pk3, snippets/carnis-kjop-3pk.liquid). Tredje modus «pk3»: to antallsvelgere
     som alltid gir 3 til sammen. Valgt miks = variant av produktet carnis-3-pakk; kjøpsknappen bytter variant-ID i skjemaet
     (temaets product-form legger den i handlekurven som vanlig), totalen, kvitteringen og sparingen følger miksen.
     Vipps-knappen vises bare for 3 × Storfetalg (workeren har samme pris, /kjop/talg?antall=3); ellers betaler kunden med
     Vipps, Klarna eller kort i kassen. ?kjop=3pakk velger 3-pakken. Abonnementet ligger bak «Velg abonnement»
     (data-ck-abo-reveal / data-ck-abo-wrap) og vises når det velges.
   Ingen avhengigheter utover temaets product-form.js og pubsub.js. */
(function () {
  'use strict';
  if (window.CarnisKjop) return;
  window.CarnisKjop = { version: 13 };

  var NB = ' ';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 387 kr · 1 023,30 kr · 1 116 kr (hardt mellomrom som tusenskille og før «kr»), likt snippets/carnis-kr.liquid
  function fmt(cents) {
    var v = Math.round(Number(cents) || 0);
    var neg = v < 0;
    if (neg) v = -v;
    var kr = Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, NB);
    var ore = v % 100;
    return (neg ? '−' : '') + kr + (ore ? ',' + ('0' + ore).slice(-2) : '') + NB + 'kr';
  }
  window.CarnisKjop.fmt = fmt;
  function tpl(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] !== undefined ? map[k] : m; });
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function setText(root, sel, txt) { qsa(root, sel).forEach(function (el) { el.textContent = txt; }); }
  function scrollTo(el, block) {
    if (el) el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: block || 'start' });
  }

  /* ---------------- Ett kjøpsvalg ---------------- */
  function initComponent(el) {
    if (el.dataset.ckReady) return;
    el.dataset.ckReady = '1';
    var cfg = {};
    try { cfg = JSON.parse((qs(el, '[data-ck-config]') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
    var t = cfg.t || {};
    var isPack = cfg.kind === 'pack';
    var limOnce = cfg.once || { def: 1, min: 1, max: 10 };
    var abo = cfg.abo || null;
    var items = abo && abo.items ? abo.items : [];
    var aboMin = abo ? Number(abo.min) || 3 : 3;
    // Mengderabatt ved engangskjøp: fra tierMin stk koster hver tierEach (øre)
    var tierMin = Number(limOnce.tierMin) || 0;
    var tierEach = Number(limOnce.tierEach) || 0;
    if (!(tierMin > 1 && tierEach > 0 && tierEach < Number(cfg.base))) { tierMin = 0; tierEach = 0; }
    function onceEach(q) { return tierMin && q >= tierMin ? tierEach : Number(cfg.base); }
    var aboMax = abo ? Number(abo.max) || 12 : 12;
    // 3-pakk (nov. 2026)
    var pk3 = cfg.pk3 && cfg.pk3.variants && cfg.pk3.variants.length ? cfg.pk3 : null;
    var pkVariants = pk3 ? pk3.variants : [];
    var pkOnly = !!(pk3 && pk3.only);
    var PK_KEYS = ['talg', 'organmix'];
    var pkShown = null;

    var form = qs(el, 'form');
    var productForm = qs(el, 'product-form');
    var inQty = qs(el, '[data-ck-qty-field]');
    var btn = qs(el, '[data-ck-atc]');
    var btnLabel = qs(el, '[data-ck-atc-label]');
    var soldOut = !!(btn && (btn.hasAttribute('data-ck-base-off') || (btn.disabled && !pk3)));
    var modeInputs = qsa(el, '[data-ck-mode]');
    var opts = qsa(el, '[data-ck-opt]');
    var qOnceIn = qs(el, '[data-ck-q="once"]');
    var aboBtn = qs(el, '[data-ck-abo-add]');
    var aboBtnLabel = qs(el, '[data-ck-abo-add-label]');
    var aboVipps = qs(el, '[data-ck-abo-vipps]');
    var aboErr = qs(el, '[data-ck-abo-err]');
    var mndInputs = qsa(el, '[data-ck-abo-mnd]');
    var idInput = form ? qs(form, 'input[name="id"]') : null;
    var baseId = idInput ? (idInput.getAttribute('data-ck-base-id') || idInput.value) : '';
    var baseOff = !!(idInput && idInput.hasAttribute('data-ck-base-off'));
    var aboWrap = qs(el, '[data-ck-abo-wrap]');
    var aboReveal = qs(el, '[data-ck-abo-reveal]');
    var pkVipps = qs(el, '[data-ck-pk3-vipps]');
    function modeOf(v) {
      if (v === 'sub' && abo) return 'sub';
      if (v === 'pk3' && pk3) return 'pk3';
      return pkOnly ? 'pk3' : 'once';
    }

    function clamp(v, lim) {
      v = parseInt(v, 10);
      if (!v || isNaN(v)) v = lim.def;
      return Math.max(lim.min, Math.min(lim.max, v));
    }
    function clampAbo(v) {
      v = parseInt(v, 10);
      if (isNaN(v) || v < 0) v = 0;
      return Math.min(aboMax, v);
    }
    var state = {
      mode: modeOf(el.getAttribute('data-mode') || 'once'),
      qOnce: clamp(qOnceIn ? qOnceIn.value : limOnce.def, limOnce),
      mnd: abo ? (Number(abo.mnd) || 3) : 3,
      q: {}
    };
    items.forEach(function (it) {
      var inp = qs(el, '[data-ck-abo-q="' + it.key + '"]');
      state.q[it.key] = it.available === false ? 0 : clampAbo(inp ? inp.value : it.def);
    });
    state.pk = { talg: 0, organmix: 0 };
    if (pk3) {
      var pkDef = pk3.def || {};
      state.pk.talg = Math.max(0, Math.min(3, parseInt(pkDef.talg, 10) || 0));
      state.pk.organmix = 3 - state.pk.talg;
    }
    var checkedMnd = mndInputs.filter(function (i) { return i.checked; })[0];
    if (checkedMnd) state.mnd = Number(checkedMnd.value) || state.mnd;

    // ?kjop=abonnement / ?kjop=engang velger kjøpsvalget på produktsiden
    if (el.hasAttribute('data-ck-main')) {
      try {
        var want = (new URLSearchParams(window.location.search).get('kjop') || '').toLowerCase();
        if (abo && (want === 'abonnement' || want === 'sub')) state.mode = 'sub';
        else if (pk3 && (want === '3pakk' || want === '3-pakk' || want === 'pakke3' || want === 'pk3')) state.mode = 'pk3';
        // ?miks=2-1 velger miksen i 3-pakken (fra lenker og fra den gamle 3-pakk-adressen)
        var miks = (new URLSearchParams(window.location.search).get('miks') || '').match(/^(\d)-(\d)$/);
        if (pk3 && miks && (+miks[1]) + (+miks[2]) === 3) { state.pk.talg = +miks[1]; state.pk.organmix = +miks[2]; }
        else if (want === 'engang' || want === 'once' || want === 'prov') state.mode = modeOf('once');
      } catch (e) {}
    }

    function unitWord(n) { return n === 1 ? (cfg.u1 || 'krukke') : (cfg.un || 'krukker'); }
    function kgOf(each, net) { return net > 0 ? each * 1000 / net : 0; }
    function paintSteppers(input, lim, q) {
      if (!input) return;
      var group = input.closest('.ck-qty');
      if (!group) return;
      qsa(group, '[data-ck-step]').forEach(function (b) {
        var d = Number(b.getAttribute('data-ck-step'));
        b.disabled = d < 0 ? q <= lim.min : q >= lim.max;
      });
    }

    // Carnis-pakke-abonnementet: valgte linjer, pris, sparing og om planene finnes
    function aboCalc() {
      var r = { n: 0, total: 0, save: 0, lines: [], ready: true, soldOut: '' };
      items.forEach(function (it) {
        var q = state.q[it.key] || 0;
        if (!q) return;
        r.n += q;
        r.total += q * (Number(it.sub) || 0);
        r.save += q * Math.max(0, (Number(it.once) || 0) - (Number(it.sub) || 0));
        var plan = it.plans ? String(it.plans[String(state.mnd)] || '') : '';
        if (!plan) r.ready = false;
        if (it.available === false) r.soldOut = it.name;
        r.lines.push({ id: Number(it.variant), quantity: q, selling_plan: plan ? Number(plan) : null });
      });
      // Ingen varer valgt: «åpner snart» bare når ingen av produktene har plan for intervallet
      if (!r.n) r.ready = items.some(function (it) { return it.plans && !!it.plans[String(state.mnd)]; });
      r.valid = r.n >= aboMin;
      return r;
    }
    function vippsHref() {
      var base = String((abo && abo.vipps) || '');
      if (!base) return '';
      var qT = state.q.talg || 0, qO = state.q.organmix || 0;
      return base + (base.indexOf('?') > -1 ? '&' : '?') + 'talg=' + qT + '&organmix=' + qO + '&mnd=' + state.mnd;
    }

    // 3-pakk: valgt variant (miks) og summene
    function pkFind() {
      for (var i = 0; i < pkVariants.length; i++) {
        var v = pkVariants[i];
        if (Number(v.t) === state.pk.talg && Number(v.o) === state.pk.organmix) return v;
      }
      return null;
    }
    function pkSet(key, n) {
      n = parseInt(n, 10);
      if (isNaN(n)) n = state.pk[key] || 0;
      n = Math.max(0, Math.min(3, n));
      state.pk[key] = n;
      state.pk[key === 'talg' ? 'organmix' : 'talg'] = 3 - n;
    }
    function pkContents(v) {
      if (!v) return '';
      var parts = [];
      PK_KEYS.forEach(function (k) {
        var n = k === 'talg' ? Number(v.t) : Number(v.o);
        if (n > 0) parts.push(n + ' ' + ((pk3.names && pk3.names[k]) || k));
      });
      return parts.join(' + ');
    }

    function render() {
      var sub = state.mode === 'sub';
      var isPk = state.mode === 'pk3';
      el.setAttribute('data-mode', state.mode);
      opts.forEach(function (o) { o.classList.toggle('is-active', o.getAttribute('data-ck-opt') === state.mode); });
      modeInputs.forEach(function (i) { i.checked = i.value === state.mode; });
      if (qOnceIn && String(qOnceIn.value) !== String(state.qOnce)) qOnceIn.value = state.qOnce;
      paintSteppers(qOnceIn, limOnce, state.qOnce);

      // Engangskjøp (med mengderabatt fra tierMin stk)
      var qo = state.qOnce;
      var eachO = onceEach(qo);
      var onceTotal = eachO * qo;
      var onceWas = Number(cfg.base) * qo;
      setText(el, '[data-ck-once-total]', fmt(onceTotal));
      qsa(el, '[data-ck-once-was]').forEach(function (w) { w.textContent = onceWas > onceTotal ? fmt(onceWas) : ''; w.hidden = !(onceWas > onceTotal); });
      qsa(el, '[data-ck-once-small]').forEach(function (s) {
        s.textContent = qo > 1 ? tpl(t.onceSmall, { n: qo, each: fmt(eachO) }) : '';
        s.hidden = qo <= 1;
      });
      if (tierMin) {
        // Tilbudsraden (tekst fra snippets/carnis-kjop-en.liquid) eller bekreftet rad med antall og sparing
        var tierOn = qo >= tierMin;
        qsa(el, '[data-ck-tier-pick]').forEach(function (b) { b.hidden = tierOn; });
        qsa(el, '[data-ck-tier-on]').forEach(function (x) { x.hidden = !tierOn; });
        if (tierOn) {
          setText(el, '[data-ck-tier-n]', qo + ' ' + unitWord(qo));
          setText(el, '[data-ck-tier-save]', fmt(onceWas - onceTotal));
        }
      }
      if (isPack) {
        setText(el, '[data-ck-pack-contents="once"]', tpl(t.packContents, { n: qo }));
        qsa(el, '[data-ck-once-save]').forEach(function (s) {
          var sv = (Number(cfg.sepEach) - cfg.base) * qo;
          s.textContent = tpl(t.packOnceSave, { save: fmt(sv) });
          s.hidden = !(sv > 0);
        });
      }
      qsa(el, '[data-ck-max]').forEach(function (m) {
        var atMax = qo >= limOnce.max;
        m.textContent = atMax ? tpl(t.maxNote, { max: limOnce.max, unit: unitWord(limOnce.max) }) : '';
        m.hidden = !atMax;
      });
      var atc = tpl(t.atcOnce, { total: fmt(onceTotal) });

      // 3-pakk: velgerne, kvitteringen, merket og knappen
      var pv = pk3 ? pkFind() : null;
      if (pk3) {
        PK_KEYS.forEach(function (k) {
          var q = state.pk[k] || 0;
          var inp = qs(el, '[data-ck-pk3-q="' + k + '"]');
          if (inp && String(inp.value) !== String(q)) inp.value = q;
          var row = qs(el, '[data-ck-pk3-row="' + k + '"]');
          if (row) {
            row.classList.toggle('is-on', q > 0);
            qsa(row, '[data-ck-pk3-step]').forEach(function (b) {
              var d = Number(b.getAttribute('data-ck-pk3-step'));
              b.disabled = d < 0 ? q <= 0 : q >= 3;
            });
          }
          qsa(el, '[data-ck-pk3-line="' + k + '"]').forEach(function (li) {
            li.hidden = q <= 0;
            setText(li, '[data-ck-pk3-line-name]', tpl(t.pk3Line || '[n] × [name]', { n: q, name: (pk3.names && pk3.names[k]) || k }).replace(/ × /, NB + '×' + NB));
            setText(li, '[data-ck-pk3-line-amt]', fmt(q * (Number(pk3.once && pk3.once[k]) || 0)));
          });
        });
        var pkSave = pv ? Math.max(0, Number(pv.was) - Number(pv.price)) : 0;
        if (pv) {
          setText(el, '[data-ck-pk3-total]', fmt(pv.price));
          setText(el, '[data-ck-pk3-head-total]', fmt(pv.price));
          setText(el, '[data-ck-pk3-avg]', fmt(Math.round(Number(pv.price) / 300) * 100));
          qsa(el, '[data-ck-pk3-was], [data-ck-pk3-head-was]').forEach(function (w) { w.textContent = fmt(pv.was); w.hidden = !(pkSave > 0); });
          setText(el, '[data-ck-pk3-disc]', '−' + fmt(pkSave));
          qsa(el, '[data-ck-pk3-discline]').forEach(function (x) { x.hidden = !(pkSave > 0); });
          qsa(el, '[data-ck-pk3-save]').forEach(function (x) {
            x.innerHTML = 'Du sparer <b>' + esc(fmt(pkSave)) + '</b> mot å kjøpe hver for seg';
            x.hidden = !(pkSave > 0);
          });
          qsa(el, '[data-ck-pk3-badge]').forEach(function (b) { b.textContent = tpl(t.pk3Badge || 'Spar [save]', { save: fmt(pkSave) }); b.hidden = !(pkSave > 0); });
        }
        qsa(el, '[data-ck-pk3-soldout]').forEach(function (x) { x.hidden = !!(pv && pv.available); });
        // Vipps rett fra produktsiden bare for 3 × Storfetalg (samme pris i workeren)
        var vOk = isPk && pv && Number(pv.t) === 3 && pv.available && !!pk3.vipps3t;
        el.toggleAttribute('data-pk3-vipps', !!vOk);
        if (pkVipps && pk3.vipps3t) pkVipps.setAttribute('href', pk3.vipps3t);
        // På 3-pakken selv: bildet og adressen (?variant=) følger miksen
        if (pkOnly && pv && el.hasAttribute('data-ck-main') && pkShown !== pv.id) {
          var first = pkShown === null;
          pkShown = pv.id;
          var mroot = el.closest('[data-cpdp-main]') || document;
          var trk = qs(mroot, '[data-cpdp-track]');
          var sl = pv.media && trk ? qs(trk, '[data-media-id="' + pv.media + '"]') : null;
          if (sl) trk.scrollTo({ left: sl.offsetLeft - trk.offsetLeft, behavior: first || reduceMotion ? 'auto' : 'smooth' });
          try {
            var u = new URL(window.location.href);
            if (first && !u.searchParams.get('variant')) { /* startvalget beholdes uten ?variant= */ }
            else { u.searchParams.set('variant', pv.id); window.history.replaceState(window.history.state, '', u.toString()); }
          } catch (e) {}
        }
      }

      // Skjemaet: 3-pakk-varianten eller produktet på siden
      if (isPk && pv) {
        if (idInput) { idInput.value = pv.id; idInput.disabled = !pv.available; }
        if (btn) btn.disabled = !pv.available;
        if (inQty) inQty.value = 1;
        if (btnLabel) {
          btnLabel.textContent = pv.available ? tpl(t.pk3Btn || t.atcOnce, { total: fmt(pv.price) }) : (t.pk3SoldOut || 'Utsolgt');
        }
      } else {
        if (idInput && baseId) { idInput.value = baseId; idInput.disabled = baseOff; }
        if (btn && pk3) btn.disabled = soldOut;
        if (btnLabel && !soldOut) btnLabel.textContent = atc;
        if (inQty) inQty.value = qo;
      }

      // Abonnementet bak lenken: vises når det er valgt
      if (aboWrap && sub) aboWrap.hidden = false;
      if (aboReveal) aboReveal.hidden = !!(aboWrap && !aboWrap.hidden);

      // Carnis-pakke-abonnementet
      var a = abo ? aboCalc() : null;
      if (abo) {
        items.forEach(function (it) {
          var inp = qs(el, '[data-ck-abo-q="' + it.key + '"]');
          var q = state.q[it.key] || 0;
          if (inp && String(inp.value) !== String(q)) inp.value = q;
          var row = qs(el, '[data-ck-abo-row="' + it.key + '"]');
          if (row) {
            row.classList.toggle('is-on', q > 0);
            qsa(row, '[data-ck-abo-step]').forEach(function (b) {
              var d = Number(b.getAttribute('data-ck-abo-step'));
              b.disabled = it.available === false ? true : (d < 0 ? q <= 0 : q >= aboMax);
            });
          }
        });
        mndInputs.forEach(function (i) {
          i.checked = Number(i.value) === state.mnd;
          var lab = i.closest('label');
          if (lab) lab.classList.toggle('is-on', i.checked);
        });
        setText(el, '[data-ck-abo-total]', fmt(a.total));
        var was = a.total + a.save;
        qsa(el, '[data-ck-abo-was]').forEach(function (w) { w.textContent = fmt(was); w.hidden = !(a.save > 0 && a.n > 0); });
        var pct = was > 0 ? Math.round(a.save / was * 100) : 0;
        qsa(el, '[data-ck-abo-pct]').forEach(function (b) { b.textContent = '−' + pct + NB + '%'; b.hidden = !(pct > 0 && a.n > 0); });
        setText(el, '[data-ck-abo-count]', a.n === 1 ? t.aboCount1 : tpl(t.aboCount, { n: a.n }));
        qsa(el, '[data-ck-abo-save]').forEach(function (s) {
          s.textContent = tpl(t.aboSave, { save: fmt(a.save) });
          s.hidden = !(a.save > 0 && a.n > 0);
        });
        qsa(el, '[data-ck-abo-min]').forEach(function (m) {
          m.textContent = tpl(t.aboMin, { min: aboMin });
          m.hidden = a.valid;
        });
        var canAdd = a.valid && a.ready && !a.soldOut;
        if (aboBtn) {
          aboBtn.disabled = !canAdd;
          aboBtn.toggleAttribute('data-ck-abo-soon', a.valid && !a.ready);
        }
        if (aboBtnLabel) {
          aboBtnLabel.textContent = !a.ready
            ? (t.aboSoon || 'Abonnement åpner snart')
            : (a.valid ? tpl(t.aboBtn, { total: fmt(a.total) }) : (t.aboBtnPlain || 'Abonner'));
        }
        if (aboVipps) {
          var href = vippsHref();
          var vOk = a.valid && !a.soldOut && !!href;
          if (vOk) { aboVipps.setAttribute('href', href); aboVipps.removeAttribute('aria-disabled'); aboVipps.removeAttribute('tabindex'); }
          else { aboVipps.removeAttribute('href'); aboVipps.setAttribute('aria-disabled', 'true'); aboVipps.setAttribute('tabindex', '-1'); }
        }
        if (aboErr && a.soldOut) { aboErr.textContent = tpl(t.aboSoldOut, { name: a.soldOut }); aboErr.hidden = false; aboErr.setAttribute('data-soldout', ''); }
        else if (aboErr && aboErr.hasAttribute('data-soldout')) { aboErr.hidden = true; aboErr.removeAttribute('data-soldout'); }
      }

      // Hendelse til produktsiden (pris under tittelen, kjøpslinja nederst)
      var me = null;
      items.forEach(function (it) { if (it.handle === cfg.handle) me = it; });
      var each = sub && me ? Number(me.sub) : eachO;
      var pkOn = isPk && !!pv;
      var pkEach = 0, pkWas = 0;
      if (pkOn) {
        if (pkOnly || !(Number(pk3.headEach) > 0)) { pkEach = Number(pv.price); pkWas = Number(pv.was) > pkEach ? Number(pv.was) : 0; }
        else { pkEach = Number(pk3.headEach); pkWas = Number(pk3.headWas) > pkEach ? Number(pk3.headWas) : 0; }
      }
      var net = Number(cfg.net) || 0;
      var detail = {
        uid: el.getAttribute('data-ck-uid'),
        kind: cfg.kind, handle: cfg.handle, mode: state.mode,
        q: pkOn ? 3 : (sub ? a.n : qo),
        total: pkOn ? Number(pv.price) : (sub ? a.total : onceTotal),
        each: pkOn ? pkEach : each,
        was: pkOn ? pkWas : (sub ? (me && Number(me.once) > each ? Number(me.once) : 0) : (Number(cfg.base) > each ? Number(cfg.base) : 0)),
        kg: 0,
        u1: pkOn ? (pkOnly ? 'pakke' : (cfg.u1 || 'krukke')) : (cfg.u1 || 'krukke'),
        pk3: pkOn ? { t: Number(pv.t), o: Number(pv.o), id: pv.id, price: Number(pv.price), was: Number(pv.was), available: !!pv.available } : null,
        base: cfg.base, sepEach: cfg.sepEach,
        blocked: pkOn ? !pv.available : (sub ? !(a.valid && a.ready) : false),
        label: sub ? (aboBtnLabel ? aboBtnLabel.textContent : '') : (pkOn && btnLabel ? btnLabel.textContent : atc),
        unit: unitWord(qo),
        mnd: state.mnd,
        sticky: pkOn
          ? tpl(t.pk3Sticky || '3-pakk · [contents] · [total]', { contents: pkContents(pv), total: fmt(pv.price) })
          : (sub
            ? tpl(t.stickySub, { n: a.n, total: fmt(a.total) })
            : tpl(t.stickyOnce, { n: qo, unit: unitWord(qo), total: fmt(onceTotal) })),
        stickyBtn: sub ? (t.stickyBtnSub || 'Abonner') : (t.stickyBtnOnce || atc)
      };
      el.ckState = detail;
      try { el.dispatchEvent(new CustomEvent('carnis:kjop', { bubbles: true, detail: detail })); } catch (e) {}
    }

    // Valg
    modeInputs.forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) { state.mode = modeOf(i.value); render(); } });
    });
    // Antall, engangskjøp
    qsa(el, '[data-ck-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = Number(b.getAttribute('data-ck-step')) || 0;
        state.qOnce = clamp(state.qOnce + d, limOnce);
        state.mode = modeOf('once');
        render();
      });
    });
    if (qOnceIn) {
      var readOnce = function (final) {
        if (qOnceIn.value === '' && !final) return;
        state.qOnce = clamp(qOnceIn.value, limOnce);
        render();
      };
      qOnceIn.addEventListener('input', function () { readOnce(false); });
      qOnceIn.addEventListener('change', function () { readOnce(true); });
      qOnceIn.addEventListener('blur', function () { readOnce(true); });
    }
    // Tilbudsraden «Velg 3 →»: velger mengderabatten
    qsa(el, '[data-ck-tier-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!tierMin) return;
        state.qOnce = clamp(tierMin, limOnce);
        state.mode = 'once';
        render();
      });
    });
    // 3-pakk: antall (alltid 3 til sammen), «Velg 3-pakk →» og lenken til abonnementet
    qsa(el, '[data-ck-pk3-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('[data-ck-pk3-row]');
        var key = row ? row.getAttribute('data-ck-pk3-row') : '';
        if (!key || !pk3) return;
        pkSet(key, (state.pk[key] || 0) + (Number(b.getAttribute('data-ck-pk3-step')) || 0));
        state.mode = 'pk3';
        render();
      });
    });
    qsa(el, '[data-ck-pk3-q]').forEach(function (inp) {
      var key = inp.getAttribute('data-ck-pk3-q');
      function read(final) {
        if (inp.value === '' && !final) return;
        pkSet(key, inp.value);
        state.mode = 'pk3';
        render();
      }
      inp.addEventListener('input', function () { read(false); });
      inp.addEventListener('change', function () { read(true); });
      inp.addEventListener('blur', function () { read(true); });
    });
    qsa(el, '[data-ck-pk3-pick]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (!pk3) return;
        e.preventDefault();
        state.mode = 'pk3';
        render();
        var opt = qs(el, '[data-ck-opt="pk3"]');
        if (opt) {
          var top = opt.getBoundingClientRect().top;
          if (top < 70 || top > (window.innerHeight || 800) * 0.6) {
            window.scrollTo({ top: Math.max(0, window.pageYOffset + top - 90), behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        }
      });
    });
    if (aboReveal) aboReveal.addEventListener('click', function () {
      if (aboWrap) aboWrap.hidden = false;
      state.mode = 'sub';
      render();
      var opt = qs(el, '[data-ck-opt="sub"]');
      if (opt) scrollTo(opt, 'center');
    });

    // Antall og intervall, abonnement
    qsa(el, '[data-ck-abo-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('[data-ck-abo-row]');
        var key = row ? row.getAttribute('data-ck-abo-row') : '';
        if (!key) return;
        var d = Number(b.getAttribute('data-ck-abo-step')) || 0;
        state.q[key] = clampAbo((state.q[key] || 0) + d);
        state.mode = 'sub';
        if (aboErr) aboErr.hidden = true;
        render();
      });
    });
    qsa(el, '[data-ck-abo-q]').forEach(function (inp) {
      var key = inp.getAttribute('data-ck-abo-q');
      function read(final) {
        if (inp.value === '' && !final) return;
        state.q[key] = clampAbo(inp.value);
        state.mode = 'sub';
        render();
      }
      inp.addEventListener('input', function () { read(false); });
      inp.addEventListener('change', function () { read(true); });
      inp.addEventListener('blur', function () { read(true); });
    });
    mndInputs.forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) { state.mnd = Number(i.value) || 3; state.mode = 'sub'; render(); } });
    });

    // «Abonner»: legg linjene i handlekurven med riktig plan og gå til handlekurven
    if (aboBtn) aboBtn.addEventListener('click', function () {
      var a = aboCalc();
      if (!a.valid || !a.ready || a.soldOut || aboBtn.disabled) { render(); return; }
      aboBtn.disabled = true;
      aboBtn.classList.add('loading');
      aboBtn.setAttribute('aria-busy', 'true');
      var sp = qs(aboBtn, '.loading__spinner');
      if (sp) sp.classList.remove('hidden');
      if (aboErr) aboErr.hidden = true;
      var url = ((abo && abo.addUrl) || (window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      var lines = a.lines.map(function (l) { return { id: l.id, quantity: l.quantity, selling_plan: l.selling_plan }; });
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: lines })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart');
          return j;
        });
      }).then(function () {
        window.location.href = (abo && abo.cartUrl) || (window.routes && window.routes.cart_url) || '/cart';
      }).catch(function (err) {
        aboBtn.classList.remove('loading');
        aboBtn.removeAttribute('aria-busy');
        if (sp) sp.classList.add('hidden');
        if (aboErr) {
          aboErr.textContent = (err && err.message && err.message !== 'cart') ? err.message : (t.aboErr || '');
          aboErr.hidden = false;
        }
        render();
      });
    });
    if (aboVipps) aboVipps.addEventListener('click', function (e) {
      if (aboVipps.getAttribute('aria-disabled') === 'true' || !aboVipps.getAttribute('href')) { e.preventDefault(); }
    });

    // Før temaets product-form sender skjemaet (engangskjøp): fjern felt som apper har lagt inn
    if (productForm && form) {
      productForm.addEventListener('submit', function (e) {
        if (state.mode === 'sub') { e.preventDefault(); e.stopImmediatePropagation(); return; }
        qsa(form, '[name="selling_plan"]').forEach(function (x) { if (x.parentNode) x.parentNode.removeChild(x); });
        qsa(form, '[name="quantity"]').forEach(function (x) { if (x !== inQty && x.parentNode) x.parentNode.removeChild(x); });
        if (state.mode === 'pk3' && pk3) {
          var pvS = pkFind();
          if (!pvS || !pvS.available) { e.preventDefault(); e.stopImmediatePropagation(); render(); return; }
          if (idInput) { idInput.value = pvS.id; idInput.disabled = false; }
          if (inQty) inQty.value = 1;
          return;
        }
        if (idInput && baseId) idInput.value = baseId;
        if (inQty) inQty.value = state.qOnce;
      }, true);
    }

    // For knapper i andre seksjoner og forsidens «Velg abonnement»-knapper
    el.ckChoose = function (mode) {
      state.mode = modeOf(mode);
      if (state.mode === 'sub' && aboWrap) aboWrap.hidden = false;
      render();
    };
    el.ckSubmit = function () {
      if (state.mode === 'sub') { if (aboBtn && !aboBtn.disabled) aboBtn.click(); else scrollTo(el, 'start'); return; }
      if (btn && !btn.disabled) {
        if (form && typeof form.requestSubmit === 'function') form.requestSubmit(btn); else btn.click();
      }
    };
    var card = el.closest('[data-cfs-card]');
    if (card) card.cfsChoose = function (mode) { el.ckChoose(mode); };

    render();
  }

  /* ---------------- Produktsiden: pris under tittelen, elementer per valg og kjøpslinja ---------------- */
  function onChange(e) {
    var el = e.target;
    var d = e.detail || {};
    if (!el || !el.hasAttribute || !el.hasAttribute('data-ck-main')) return;
    var root = el.closest('[data-cpdp-main], [data-cpk-main]') || document;

    // Pris under tittelen: pris per krukke/boks/pakke for valgt kjøp (og kilopris for Storfetalg).
    // 3-pakk (nov. 2026): prisen for valgt miks og «for 3 krukker · hver for seg X kr» (ingen gjennomstreking – ikke en førpris).
    qsa(root, '[data-ck-head]').forEach(function (h) {
      if (d.mode === 'pk3' && d.pk3) {
        setText(h, '[data-ck-head-price]', fmt(d.pk3.price));
        setText(h, '[data-ck-head-unit]', 'for 3 krukker');
        qsa(h, '[data-ck-head-was]').forEach(function (w) { w.textContent = ''; w.hidden = true; });
        return;
      }
      setText(h, '[data-ck-head-price]', fmt(d.each));
      if (d.mode === 'sub' && d.was) {
        // Abonnement: engangsprisen som tekst, ikke gjennomstreket (nov. 2026)
        setText(h, '[data-ck-head-unit]', 'per ' + (d.u1 || 'krukke') + ' på abonnement · engangspris ' + fmt(d.was));
        qsa(h, '[data-ck-head-was]').forEach(function (w) { w.textContent = ''; w.hidden = true; });
        return;
      }
      setText(h, '[data-ck-head-unit]', 'per ' + (d.u1 || 'krukke'));
      qsa(h, '[data-ck-head-was]').forEach(function (w) { w.textContent = d.was ? fmt(d.was) : ''; w.hidden = !d.was; });
    });
    // Elementer som bare gjelder ett av valgene
    qsa(root, '[data-ck-show]').forEach(function (x) { x.hidden = (' ' + (x.getAttribute('data-ck-show') || '') + ' ').indexOf(' ' + d.mode + ' ') < 0; });
    // Kjøpslinja nederst
    qsa(document, '[data-ck-sticky]').forEach(function (s) {
      if (s.getAttribute('data-ck-for') !== el.id) return;
      setText(s, '[data-ck-sticky-meta]', d.sticky || '');
      setText(s, '[data-ck-sticky-label]', d.stickyBtn || '');
      // 3-pakk uten Vipps-lenke (alle mikser unntatt 3 × Storfetalg): Vipps-delen av kjøpslinja skjules
      var sv = qs(s, '[data-ck-sticky-vipps]');
      if (sv) sv.hidden = d.mode === 'pk3' && !el.hasAttribute('data-pk3-vipps');
    });
  }

  /* ---------------- Kjøpslinje nederst (produktsiden) ----------------
     Okt. 2026 (v11): vises bare etter at kunden har scrollet forbi kjøpsknappen (engangskjøp eller «Abonner»),
     på PC og mobil. Aldri ved første visning, aldri mens kjøpsvalgene eller knappen er på skjermen
     (da dekket den abonnementsvalget), og ikke når bunnen av siden er synlig. */
  function initSticky(s) {
    if (s.dataset.ckReady) return;
    s.dataset.ckReady = '1';
    var comp = document.getElementById(s.getAttribute('data-ck-for') || '');
    if (!comp) return;
    var targets = qsa(comp, '[data-ck-atc], [data-ck-abo-actions]');
    if (!targets.length) return;
    var footer = document.querySelector('footer, .footer, [id*="footer"]');
    var raf = 0;
    // Regnes fra posisjonen ved hver scroll (ikke IntersectionObserver): et hopp rett til toppen eller bunnen
    // (f.eks. trykk på statuslinjen i iOS) passerer ikke knappen og ville ellers latt linja stå igjen.
    function paint() {
      raf = 0;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var above = false, seen = false;
      targets.forEach(function (tg) {
        var r = tg.getBoundingClientRect();
        if (!r.height) return; // skjult knapp (det andre kjøpsvalget) teller ikke
        if (r.bottom <= 0) above = true;
        else if (r.top < vh) seen = true;
      });
      var footerSeen = false;
      if (footer) { var fr = footer.getBoundingClientRect(); footerSeen = fr.height > 0 && fr.top < vh && fr.bottom > 0; }
      var show = above && !seen && !footerSeen;
      s.classList.toggle('is-visible', show);
      s.classList.toggle('is-intro', !above);
      s.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    function queue() { if (!raf) raf = window.requestAnimationFrame(paint); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    document.addEventListener('carnis:kjop', queue);
    paint();
    var sbtn = qs(s, '[data-ck-sticky-btn]');
    if (sbtn) sbtn.addEventListener('click', function () {
      var st = comp.ckState || {};
      if (s.classList.contains('is-intro') || st.blocked) { scrollTo(comp, 'start'); return; }
      if (comp.ckSubmit) comp.ckSubmit();
    });
    // Vipps-delen av kjøpsknappen nederst: samme Vipps-lenke som valget over (engangskjøp eller abonnement)
    var sv = qs(s, '[data-ck-sticky-vipps]');
    if (sv) sv.addEventListener('click', function (e) {
      e.preventDefault();
      var st = comp.ckState || {};
      var href = '';
      if (st.mode === 'sub') {
        var av = qs(comp, '[data-ck-abo-vipps]');
        href = av && av.getAttribute('aria-disabled') !== 'true' ? (av.getAttribute('href') || '') : '';
      } else if (st.mode === 'pk3') {
        var pa = qs(comp, '[data-ck-pk3-vipps]');
        href = comp.hasAttribute('data-pk3-vipps') && pa ? (pa.getAttribute('href') || '') : '';
      } else {
        var ov = qs(comp, '.vab__once');
        href = ov ? String(ov.getAttribute('href') || '').replace(/antall=\d+/, 'antall=' + (st.q || 1)) : '';
      }
      if (href) window.location.href = href; else scrollTo(comp, 'start');
    });
    var change = qs(s, '[data-ck-sticky-change]');
    if (change) change.addEventListener('click', function () { scrollTo(comp, 'start'); });
    if (comp.ckState) {
      setText(s, '[data-ck-sticky-meta]', comp.ckState.sticky || '');
      setText(s, '[data-ck-sticky-label]', comp.ckState.stickyBtn || '');
    }
  }

  /* ---------------- Knapper i andre seksjoner på produktsiden ----------------
     data-cpdp-choose="sub:…" / "once:…" velger kjøpsvalget i produktkortet øverst og ruller dit. */
  function onChoose(e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-cpdp-choose]') : null;
    if (!a) return;
    var comp = document.querySelector('[data-ck-main]');
    if (!comp || !comp.ckChoose) return;
    var mode = (a.getAttribute('data-cpdp-choose') || '').split(':')[0];
    comp.ckChoose(mode === 'sub' || mode === 'pk3' ? mode : 'once');
    e.preventDefault();
    scrollTo(comp, 'start');
  }

  document.addEventListener('carnis:kjop', onChange);
  document.addEventListener('click', onChoose);

  function boot() {
    qsa(document, '[data-ck]').forEach(initComponent);
    qsa(document, '[data-ck-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
